import * as React from 'react';
import { render } from 'react-dom';
import { RouterProvider } from 'react-router5';
import { Router } from 'router5';
import { AppContainer } from './container/app.container';
//import "./manifest.json";
import configureRouter from './router/config';
import "./styles/main-style.scss";
import 'bootstrap/dist/css/bootstrap.css';  

const router: Router = configureRouter(window.location.hostname === "localhost");

router.start(() => {
    render(
        
    <RouterProvider router = {router}>
        <AppContainer />
    </RouterProvider>
    , document.getElementById("root"))
})
